export const FIRMWARE_ASSIGN_OPEN_MODAL = "FIRMWARE_ASSIGN_OPEN_MODAL";

export const FIRMWARE_ASSIGN_GET_FIRMWARE_REQUEST = "FIRMWARE_ASSIGN_GET_FIRMWARE_REQUEST";
export const FIRMWARE_ASSIGN_GET_FIRMWARE_RESULT = "FIRMWARE_ASSIGN_GET_FIRMWARE_RESULT";

export const FIRMWARE_ASSIGN_GET_DEVICE_REQUEST = "FIRMWARE_ASSIGN_GET_DEVICE_REQUEST";
export const FIRMWARE_ASSIGN_GET_DEVICE_RESULT = "FIRMWARE_ASSIGN_GET_DEVICE_RESULT";

export const FIRMWARE_ASSIGN_FIRMWARE_REQUEST = "FIRMWARE_ASSIGN_FIRMWARE_REQUEST";
export const FIRMWARE_ASSIGN_FIRMWARE_RESULT = "FIRMWARE_ASSIGN_FIRMWARE_RESULT";

export const FIRMWARE_ASSIGN_SET_DEVICES = "FIRMWARE_ASSIGN_SET_DEVICES";
